import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import publicIp from 'public-ip';
import { createInstance, HackleProvider } from '@hackler/react-sdk';
import AppConfig from '@config';
import { RootState } from '@modules/index';

const hackleClient = (window as Window & { Cypress?: any }).Cypress
  ? undefined
  : createInstance(AppConfig.hackleSdkKey as string, {
      auto_track_page_view: true,
      debug: AppConfig.mode !== 'production' ? true : false
    });

const HackleCustomProvider: React.FC = ({ children }) => {
  const [userIp, setUserIp] = useState<string>('');
  const userId = useSelector<RootState, string | undefined>(
    (state) => state.client.id
  );
  const userEmail = useSelector<RootState, string | undefined>(
    (state) => state.client.email
  );

  useEffect(() => {
    publicIp
      .v4()
      .then((ip) => setUserIp(ip))
      .catch((e) => setUserIp(''));
  }, []);

  if (!hackleClient) return <>{children}</>;

  return (
    <HackleProvider
      hackleClient={hackleClient}
      user={{
        id: userId ?? userIp,
        properties: userEmail
          ? {
              email: userEmail
            }
          : undefined
      }}
    >
      {children}
    </HackleProvider>
  );
};

export default HackleCustomProvider;
